import { BooleanFilterOperator, GridFilterValue } from './operators';
import { ScalarFilterValue } from './types';
import { neverReached } from 'shared/utils/neverReached';

export function matchesBooleanFilter(
  operator: BooleanFilterOperator,
  filterValue: ScalarFilterValue,
  cellValue: ScalarFilterValue
): boolean {
  const cellBool = Boolean(cellValue);
  const filterBool = Boolean(filterValue);

  switch (operator) {
    case GridFilterValue.IS:
      return cellBool === filterBool;
    case GridFilterValue.NOT:
      return cellBool !== filterBool;
    default:
      return neverReached(operator);
  }
}
